import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../utils";

const Courses = () => {
    const [activeTab, setActiveTab] = useState("9th, 10th");
    const [categoryTestData, setCategoryTestData] = useState([]);
    const [studyMaterial, setStudyMaterial] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(true); // For category loading
    const [loadingMaterials, setLoadingMaterials] = useState(true); // For study materials loading

    // Fetch categories
    const fetchCategories = async () => {
        setLoadingCategories(true);
        try {
            const response = await axios.get(getBaseUrl() + "user_api/categoryTest");
            if (response.data && response.data.results) {
                setCategoryTestData(response.data.results);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoadingCategories(false);
        }
    };

    // Fetch study materials based on catId
    const fetchStudyMaterials = async (catId = "") => {
        setLoadingMaterials(true);
        try {
            const response = await axios.get(
                `${getBaseUrl()}user_api/studyMaterialListWEB`,
                { params: { catId } } // Pass catId as query parameter
            );
            if (response.data && response.data.results) {
                setStudyMaterial(response.data.results);
            }
        } catch (error) {
            console.error("Error fetching study materials:", error);
        } finally {
            setLoadingMaterials(false);
        }
    };

    // Handle tab click and update active tab + study materials
    const handleTabClick = (tab) => {
        setActiveTab(tab.name);
        fetchStudyMaterials(tab._id); // Assuming `tab._id` is the catId
    };

    useEffect(() => {
        fetchCategories();
        //fetchStudyMaterials(); // Fetch all study materials initially
    }, []);


    useEffect(() => {
    if (categoryTestData.length > 0) {
        const firstCategory = categoryTestData[0];
        setActiveTab(firstCategory.name);
        fetchStudyMaterials(firstCategory._id);
    }
}, [categoryTestData]);

    return (
        <div>
            <Navbar />
            <section className="bg-[#28282B] pt-[40px] pb-[40px] mt-20">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-12 Header__text text-center text-white font-[700]">
                            Courses Available
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-[#F2F2F2] pt-[30px]">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-12">
                            {loadingCategories ? (
                                <div>Loading categories...</div>
                            ) : categoryTestData.length > 0 ? (
                                <div className="tab-navigation flex gap-[50px] Paragraph__etxt">
                                    {categoryTestData.map((tab) => (
                                        <div
                                            key={tab._id} // Use unique identifier
                                            className={`tab ${activeTab === tab.name ? "active" : "inactive"
                                                }`}
                                            onClick={() => handleTabClick(tab)}
                                        >
                                            {tab.name}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div>No categories available</div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-[#F2F2F2] pt-[30px] pb-[100px]">
                <div className="container-xxl">
                    <div className="row">
                        {loadingMaterials ? (
                            <div>Loading study materials...</div>
                        ) : studyMaterial.length > 0 ? (
                            studyMaterial.map((item, index) => (
                                <div
                                    className="col-md-4 pb-[20px] pl-[15px] pr-[15px]"
                                    key={index}
                                >
                                    <div className="p-[10px] bg-[#FFFFFF] choose_qulifation_section rounded-[15px]">
                                        <div className="p-[13px]">
                                            <div className="images">
                                                <img src={item.image} alt="images" className="rounded-lg" />
                                            </div>
                                            <div className="text">
                                                <h4
                                                    className="Header__text font-[700] pt-[15px] pb-[5px]"
                                                    style={{ fontSize: "18px" }}
                                                >
                                                    {item.name}
                                                </h4>
                                                <div className="Paragraph__etxt pb-6 pb-[15px]">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: item.description,
                                                        }}
                                                    />
                                                </div>
                                                <Link to="#">
                                                    <label
                                                        className="Header__text font-[700] flex itemns-center"
                                                        style={{ fontSize: "18px" }}
                                                    >
                                                        Check Availability{" "}
                                                        <i className="ri-arrow-right-line"></i>
                                                    </label>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div>No study materials available</div>
                        )}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Courses;
